import { DocType } from '../global/Doc.enum';
import type { IJob } from './Job.interface';
import Job from './Job';

export default class JobType extends Job {
  static build = (data: IJob) => new JobType(data);
  static blank = () => new JobType({ isActive: true });

  /**
   * Constructor
   * @param {IJob} data
   */
  constructor(data?: IJob) {
    super(data, DocType.of('__definition.jobtype'));
  }
}
